import "@/App.css";
import { Toaster } from "sonner";
import { Navbar } from "@/components/Navbar";
import { Hero } from "@/components/Hero";
import { Tape } from "@/components/Tape";
import { Idea } from "@/components/Idea";
import { Elongification } from "@/components/Elongification";
import { Anatomy } from "@/components/Anatomy";
import { MenuBoard } from "@/components/MenuBoard";
import { WhyNow } from "@/components/WhyNow";
import { Stall } from "@/components/Stall";
import { LineMap } from "@/components/LineMap";
import { Stores } from "@/components/Stores";
import { Franchise } from "@/components/Franchise";
import { Footer } from "@/components/Footer";

function App() {
  return (
    <div className="App bg-pav text-kadak">
      <div className="grain-overlay" />
      <Toaster position="top-center" richColors />
      <Navbar />
      <main>
        <Hero />
        <Tape
          testid="tape-hero"
          className="-rotate-1 bg-taxi text-kadak"
          items={["LAMBA VADA. BADA MAZA.", "THE VADA PAV, UNCURLED", "GARMA GARAM", "100% VEG", "HORN OK PAV"]}
        />
        <Idea />
        <Elongification />
        <Tape
          testid="tape-mid"
          reverse
          className="rotate-1 bg-mirchi text-pav"
          items={["ELONGIFICATION™", "UNCURLED SINCE 2026", "POTATO END TO END", "FRIES IN 90 SECONDS", "NO ROLL, NO DROP"]}
        />
        <Anatomy />
        <MenuBoard />
        <WhyNow />
        <Stall />
        <LineMap />
        <Stores />
        <Franchise />
      </main>
      <Footer />
    </div>
  );
}

export default App;
